import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import r from "../../shared-lib/braze-shared-lib.js";

var u = /*#__PURE__*/function () {
  function u() {
    _classCallCheck(this, u);

    this.De = {};
  }

  _createClass(u, [{
    key: "ut",
    value: function ut(t) {
      if ("function" != typeof t) return null;
      var i = r.it.nt();
      return this.De[i] = t, i;
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(t) {
      delete this.De[t];
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      this.De = {};
    }
  }, {
    key: "St",
    value: function St(t) {
      var i = [];

      for (var _r in this.De) {
        i.push(this.De[_r](t));
      }

      return i;
    }
  }]);

  return u;
}();

export { u as default };